/* La Boîte à Idées — v2 : la boîte s'ouvre, la neige tombe. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(hero) {
    var box = hero.querySelector('.lbi-box');
    var stage = hero.querySelector('.lbi-stage');
    if (!box || !stage) return;

    function open() { stage.classList.add('is-open'); box.setAttribute('aria-expanded', 'true'); }
    function replay() {
      stage.classList.remove('is-open');
      box.setAttribute('aria-expanded', 'false');
      window.setTimeout(open, reduce ? 0 : 420);
    }

    if (reduce) { open(); } else { window.setTimeout(open, 650); }
    box.addEventListener('click', function () {
      if (stage.classList.contains('is-open')) { replay(); } else { open(); }
    });

    var canvas = hero.querySelector('.lbi-snow');
    if (canvas && !reduce) snow(canvas, hero);
  }

  function snow(canvas, host) {
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var flakes = [];
    var w = 0, h = 0, raf = null, visible = true;

    function size() {
      w = host.clientWidth; h = host.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var count = Math.round(Math.min(90, (w * h) / 14000));
      flakes = [];
      for (var i = 0; i < count; i++) {
        flakes.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: 0.8 + Math.random() * 2.4,
          s: 0.25 + Math.random() * 0.75,
          d: Math.random() * Math.PI * 2
        });
      }
    }

    function tick() {
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(244,246,255,0.75)';
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.s; f.d += 0.01; f.x += Math.sin(f.d) * 0.3;
        if (f.y > h + 4) { f.y = -4; f.x = Math.random() * w; }
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2); ctx.fill();
      }
      raf = visible ? window.requestAnimationFrame(tick) : null;
    }

    size();
    window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible && !raf) tick();
      }).observe(host);
    }
    tick();
  }

  function init() {
    document.querySelectorAll('[data-lbi-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
